import React, { useEffect, useState } from "react";
import MainPageDialog from "../../components/mainPageDialog";
import { useForm, useWatch } from "react-hook-form";
import { ReactSelectField } from "../../components/ReactHooksFormFields/ReactSelectField";
import { AsyncSelectField } from "../../components/ReactHooksFormFields/AsyncSelectField";
import {
  clinicalSummaryApi,
  useShareClinicalDataViaEmailMutation,
} from "../../redux/service/clinicalSummary_service";
import { TextareaPp } from "../../components/ReactHooksFormFields/TextareaPp";
import moment from "moment";
import { toast } from "react-toastify";
import { Loader } from "../../components/Loader";

function ShareClinicalSummaryModal({
  setOpenShareSummaryModal,
  ccdFileUrl,
  pid,
}) {
  const transmitViaOptions = [
    { label: "Email", title: "Email", value: "email", id: "email" },
    { label: "Provider", title: "Provider", value: "provider", id: "provider" },
  ];
  const [loading, setLoading] = useState(false);

  const [fetchProvidersEmailTrigger] =
    clinicalSummaryApi.endpoints.searchProvidersEmail.useLazyQuery();

  const [fetchProvidersTrigger] =
    clinicalSummaryApi.endpoints.searchProviders.useLazyQuery();

  const [saveClinicalDataViaEmailTrigger] =
    useShareClinicalDataViaEmailMutation();

  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm();

  const onSubmit = (data) => {
    if (!data?.to?.id) {
      toast.error("Please select a recipient");
      return;
    }

    setLoading(true);

    let payload = {
      action: transmitType?.value === "email" ? "transmit" : "integrity",
      action_datetime: moment().format("YYYY-MM-DD HH:MM:SS"),
      message: data?.message,
      pid,
    };

    if (transmitType?.value === "email") {
      payload["email"] = data?.to?.id;
    } else {
      payload["provider_id"] = data?.to?.id;
    }

    saveClinicalDataViaEmailTrigger(payload)
      .then((resp) => {
        if (resp?.data?.code === 0) {
          toast.success("Clinical Summary Logs sent successfully");
        }
      })
      .catch((err) => {
        console.log("Error sending clinical summary logs");
        toast.error("Error sending clinical summary logs");
      })
      .finally(() => {
        setLoading(false);
        setOpenShareSummaryModal(false);
      });
  };

  const searchEmail = async (query) => {
    if (query.length > 2) {
      const response = await fetchProvidersEmailTrigger({
        keyword: query,
      });

      const res = response?.data?.data?.map((v, k) => {
        return { id: v, title: v };
      });
      return new Promise(function (resolve, reject) {
        resolve(res || []);
      });
    }
  };

  const searchProviders = async (query) => {
    if (query.length > 2) {
      const response = await fetchProvidersTrigger({
        keyword: query,
      });
      const res = response?.data?.data?.map((v, k) => {
        return { id: v.User.id, title: v.User.name };
      });
      return new Promise(function (resolve, reject) {
        resolve(res || []);
      });
    }
  };

  const transmitType = useWatch({
    control,
    name: "transmit_via",
  });

  useEffect(() => {
    setValue("transmit_via", transmitViaOptions[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValue("to", null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transmitType]);

  const footerList = [
    {
      title: "Close",
      type: "cancel",
      action: () => {
        setOpenShareSummaryModal(false);
      },
    },
    {
      title: "Send",
      type: "save",
      action: () => {
        handleSubmit(onSubmit)();
      },
    },
  ];

  return (
    <MainPageDialog
      title="Clinical Summary Logs"
      modalSize="large"
      maxHeight={true}
      footerList={footerList}
      onCancelHandler={() => setOpenShareSummaryModal(false)}
    >
      {loading && <Loader position="absolute" />}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col gap-[20px] h-[500px]">
          <div className="flex gap-[20px] items-center">
            <div className="w-[300px]">
              <ReactSelectField
                control={control}
                name="transmit_via"
                title="Send Via"
                options={transmitViaOptions}
                errors={errors}
                menuPlacement="bottom"
                defaultValue={transmitViaOptions[0]}
              />
            </div>
            <div className="w-[300px]">
              <AsyncSelectField
                showLabel="title"
                search={(query) =>
                  transmitType?.value === "email"
                    ? searchEmail(query)
                    : searchProviders(query)
                }
                control={control}
                name="to"
                title={`To ${
                  transmitType?.value === "email" ? "Email" : "Provider"
                }`}
                errors={errors}
                menuPlacement="bottom"
                required={true}
              />
            </div>
          </div>
          <div className="flex gap-[20px] items-center">
            <p>File: {ccdFileUrl}</p>
          </div>
          <div className="flex gap-[20px] items-center">
            <TextareaPp
              control={control}
              name="message"
              title="Message"
              errors={errors}
            />
          </div>
        </div>
      </form>
    </MainPageDialog>
  );
}

export default ShareClinicalSummaryModal;
